import DOMPurify from 'dompurify';

/**
 * Format file size in human-readable format
 * @param {number} bytes - File size in bytes
 * @returns {string} Formatted size string
 */
export const formatFileSize = bytes => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * DOMPurify configuration for email HTML sanitization
 */
export const EMAIL_SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li',
    'blockquote', 'div', 'span', 'h1', 'h2', 'h3', 'h4',
    'table', 'tr', 'td', 'th', 'thead', 'tbody'
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'style'],
};

/**
 * Sanitize email HTML content
 * @param {string} html - Raw HTML content
 * @returns {string} Sanitized HTML
 */
export const sanitizeEmailHtml = html => {
  if (!html) return '';
  return DOMPurify.sanitize(html, EMAIL_SANITIZE_CONFIG);
};
